// Vendor
import $ from 'jquery';
import * as Hubspot from './hubspot';
import './nano-components';

window.$ = window.jQuery = $;
window.hbsptNpPreprocess = Hubspot;

import(/* webpackChunkName: "lsg-layout" */ 'ont-styleguide/dist/layout')

// LSG
import(/* webpackChunkName: "lsg-components" */ 'ont-styleguide/dist/components').then(({ default: LsgComps }) => {
  // load lsg components asynchronously to improve initial load time
  window.lsgPublicApi = window.lsgPublicApi || {};
  lsgPublicApi.components = LsgComps;
});

// App specific
import('../../src/app/bootstrap');

